<template>
  <div class="">
    <h1>Zapie.xyz</h1>
    <p>Fale com quem você quiser no WhatsApp, <br>
      sem precisar adicionar o contato a sua agenda</p>
    <input type="tel" v-mask="'+## (##) #####-####'" v-model="phone" placeholder="Digite o telefone"t/>
    <div class="actions">
      <a
        :href="'https://api.whatsapp.com/send?phone=' + getPhone"
        target="_blank"
        class="whatsapp"
        v-if="phone"
      >
        <img src="../assets/logo.png" class="icon">
        Conversar com {{ phone }}
      </a>

      <p v-if="name">
        Este é o número de <strong>{{ name }}</strong>!
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Index',
  components: {
    Vue,
  },
  data() {
    return {
      name: '',
      phone: '',
      whats: '',
      custom: {
        'alessandro': {
          name: 'Alessandro Stein',
          phone: '+55 (47) 99284-0161'
        },
        'luciane': {
          name: 'Luciane Kreutzfeld',
          phone: '+55 (47) 99245-0294'
        },
        'iago': {
          name: 'Iago Puccini',
          phone: '+55 (47) 99254-6273'
        },
        'angela': {
          name: 'Angela Araldi',
          phone: '+55 (47) 99121-3272'
        },
        'marco': {
          name: 'Marco Aurélio Perotti',
          phone: '+55 (47) 99997-7795'
        },
        'renaldo': {
          name: 'Renaldo Viola',
          phone: '+55 (47) 99675-6021'
        },
        'daniel': {
          name: 'Daniel Bockor',
          phone: '+55 (47) 99962-3733'
        },
        'leo': {
          name: 'Leonardo Rodrigues',
          phone: '+55 (14) 99148-6281'
        },
        'tecinformatica': {
          name: 'TEC Informática',
          phone: '+55 (47) 99135-9612'
        },
        'cristian': {
          name: 'Cristian Stein',
          phone: '+55 (47) 99135-9612'
        },
        'al': {
          name: 'AL - Camisas Personalizadas',
          phone: '+55 (47) 99284-0161'
        },
        'henrique': {
          name: 'Henrique Porto',
          phone: '+55 (47) 99991-0818'
        },
        'scfutebol': {
          name: 'SC Futebol',
          phone: '+55 (47) 99991-0818'
        },
        'adoro': {
          name: 'Loja Adoro',
          phone: '+55 (47) 99291-7980'
        },
        'planetadj': {
          name: 'Planeta DJ',
          phone: '+55 (11) 93117-1009'
        }
      }
    };
  },
  created(){
    const slug = this.$route.params.slug;
    if (slug) {
      this.fill(slug);
    }
  },
  mounted(){
    const phone = this.$route.params.phone;
    if (phone) {
      this.phone = phone;
    }
  },
  computed: {
    getPhone(){
      return this.phone.replace('+', '').replace(' ', '').replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
    }
  },
  methods: {
    fill(slug){
      const custom = this.custom[slug];
      if (custom) {
        this.name = custom.name;
        this.phone = custom.phone;
      }
    }
  },
};
</script>

<style>

  input {
    padding: 0.7rem;
    font-size: 16px;
    width: 250px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .actions {
    padding: 1rem;
  }

  .whatsapp {
    background-color: #25D366;
    border-radius: 5px;
    color: #FFF;
    display: inline-block;
    font-size: 14px;
    padding: 0.5rem 1.5rem;
    text-decoration: none;
    max-width: 270px;
    box-shadow: 0 2px 12px 0 rgba(37, 211, 102, 0.5);
  }

  .icon {
    width: 20px;
    vertical-align: sub;
  }
</style>



// WEBPACK FOOTER //
// src/views/v-index.vue